import { gql } from '@apollo/client'

const LOYALTY_MULTIPLIER_FIELDS = gql`
  fragment LoyaltyMultiplierFields on LoyaltyMultiplier {
    id
    loyaltyCardId
    loyaltyCard {
      id
      name
      stampLabel
      stampType
      archivedAt
    }
    name
    description
    factor
    startDate
    endDate
    days {
      day
      startTime
      endTime
    }
    target
    categoryIds
    productIds
    applyToModifiers
    active
    archivedAt
  }
`

export const GET_LOYALTY_MULTIPLIER = gql`
  ${LOYALTY_MULTIPLIER_FIELDS}
  query GetLoyaltyMultiplier($merchantId: uuid!, $multiplierId: uuid!) {
    loyaltyMultiplier(merchantId: $merchantId, multiplierId: $multiplierId) {
      ...LoyaltyMultiplierFields
    }
  }
`

export const GET_LOYALTY_MULTIPLIERS = gql`
  query GetLoyaltyMultipliers($merchantId: uuid!, $archived: Boolean) {
    loyaltyMultipliers(merchantId: $merchantId, archived: $archived) {
      id
      name
      factor
      target
      categoryIds
      productIds
      days {
        day
        startTime
        endTime
      }
      loyaltyCard {
        name
      }
      status
      archivedAt
    }
  }
`

export const CREATE_LOYALTY_MULTIPLIER = gql`
  mutation CreateLoyaltyMultiplier(
    $merchantId: uuid!
    $loyaltyCardId: uuid!
    $name: String!
    $description: String
    $factor: Int!
    $startDate: Date!
    $endDate: Date
    $days: [LoyaltyMultiplierDayInput!]!
    $target: LoyaltyMultiplierTarget!
    $categoryIds: [uuid!]!
    $productIds: [uuid!]!
    $applyToModifiers: Boolean!
    $active: Boolean!
  ) {
    createLoyaltyMultiplier(
      merchantId: $merchantId
      loyaltyCardId: $loyaltyCardId
      name: $name
      description: $description
      factor: $factor
      startDate: $startDate
      endDate: $endDate
      days: $days
      target: $target
      categoryIds: $categoryIds
      productIds: $productIds
      applyToModifiers: $applyToModifiers
      active: $active
    ) {
      id
    }
  }
`

export const UPDATE_LOYALTY_MULTIPLIER = gql`
  mutation UpdateLoyaltyMultiplier(
    $merchantId: uuid!
    $multiplierId: uuid!
    $name: String!
    $description: String
    $factor: Int!
    $startDate: Date!
    $endDate: Date
    $days: [LoyaltyMultiplierDayInput!]!
    $target: LoyaltyMultiplierTarget!
    $categoryIds: [uuid!]!
    $productIds: [uuid!]!
    $applyToModifiers: Boolean!
    $active: Boolean!
  ) {
    updateLoyaltyMultiplier(
      merchantId: $merchantId
      multiplierId: $multiplierId
      name: $name
      description: $description
      factor: $factor
      startDate: $startDate
      endDate: $endDate
      days: $days
      target: $target
      categoryIds: $categoryIds
      productIds: $productIds
      applyToModifiers: $applyToModifiers
      active: $active
    ) {
      id
    }
  }
`

export const SET_LOYALTY_MULTIPLIER_ACTIVE = gql`
  mutation SetLoyaltyMultiplierActive(
    $merchantId: uuid!
    $multiplierId: uuid!
    $active: Boolean!
  ) {
    setLoyaltyMultiplierActive(
      merchantId: $merchantId
      multiplierId: $multiplierId
      active: $active
    ) {
      id
      name
      active
      status
      archivedAt
    }
  }
`

export const ARCHIVE_LOYALTY_MULTIPLIER = gql`
  mutation ArchiveLoyaltyMultiplier($merchantId: uuid!, $multiplierId: uuid!) {
    archiveLoyaltyMultiplier(
      merchantId: $merchantId
      multiplierId: $multiplierId
    ) {
      id
      name
      active
      status
      archivedAt
    }
  }
`

export const UNARCHIVE_LOYALTY_MULTIPLIER = gql`
  mutation UnarchiveLoyaltyMultiplier(
    $merchantId: uuid!
    $multiplierId: uuid!
  ) {
    unarchiveLoyaltyMultiplier(
      merchantId: $merchantId
      multiplierId: $multiplierId
    ) {
      id
      name
      active
      status
      archivedAt
    }
  }
`

/**
 * The selected card's products (for the pickers) and multipliers (for the "other multipliers" hint).
 * Fields are aliased to the snake_case names the pickers read; Hasura only accepts the camelCase originals.
 */
export const GET_LOYALTY_CARD = gql`
  query GetLoyaltyCard($merchantId: uuid!, $loyaltyCardId: uuid!) {
    loyaltyCard(merchantId: $merchantId, loyaltyCardId: $loyaltyCardId) {
      id
      stampType
      categoriesWithProducts {
        id
        name
        merchant_id: merchantId
        archived_at: archivedAt
        products {
          id
          name
          sku
        }
      }
      multipliers {
        id
      }
    }
  }
`
